/**
 * Raiz de la aplicacion.
 *
 * `HelmetProvider` es lo que permite que cada vista declare sus propias
 * cabeceras (`<title>`, descripcion, canonical, Open Graph) y que al cambiar de
 * pagina las anteriores se retiren solas. Sin el, el `<head>` se quedaria con
 * el titulo de la pagina anterior.
 *
 * `ProveedorSesion` envuelve todo y no solo al backoffice porque tiene que
 * quedar por encima del enrutador: la vista de acceso y el panel son rutas
 * hermanas, y las dos necesitan la misma sesion.
 *
 * `ProveedorCarro` va por el mismo motivo: el globo de la cabecera, el boton
 * de cada tarjeta y la pantalla del carro son tres puntos distintos del arbol
 * y tienen que ver el mismo carro.
 */
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import { Enrutador } from './enrutador';
import { ProveedorCarro } from './contexto/carro';
import { ProveedorSesion } from './contexto/sesion';
import { VolverArriba } from './componentes/diseno/VolverArriba';
import { SeguimientoDePaginas } from './medicion/SeguimientoDePaginas';

export function Aplicacion() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ProveedorSesion>
          <ProveedorCarro>
            <VolverArriba />
            <SeguimientoDePaginas />
            <Enrutador />
          </ProveedorCarro>
        </ProveedorSesion>
      </BrowserRouter>
    </HelmetProvider>
  );
}
